// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';

function handleReturnStatusChange(event) {

    this.onPartReturnStatusChange(event.target.value);

}

const ReturnStatusSelect = props =>
    <div className={`return-status-select required ${props.isEditableAndAccessible ? '' : 'hide'}`}>
        {props.isEditableAndAccessible &&
            <LabeledFormInput label={props.fieldLabel}>
                <select
                    onChange={props::handleReturnStatusChange}
                    value={props.returnStatus}
                >
                    {props.partReturn.allowedReturnStatuses.map(returnStatus =>
                        <option
                            key={returnStatus.id}
                            value={returnStatus.id}
                        >
                            {returnStatus.description}
                        </option>
                    )}
                </select>

                {
                    props.isValid ? null :
                    <span className='error-message'>
                        <FormattedMessage id={props.errorMessage}/>
                    </span>
                }

            </LabeledFormInput>
        }
    </div>;

ReturnStatusSelect.displayName = 'ReturnStatusSelect';
ReturnStatusSelect.defaultProps = {
    isValid: true
};
ReturnStatusSelect.propTypes = {
    errorMessage: PropTypes.string,
    fieldLabel: PropTypes.string.isRequired,
    isEditableAndAccessible: PropTypes.bool.isRequired,
    isValid: PropTypes.bool,
    onPartReturnStatusChange: PropTypes.func.isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired,
    returnStatus: PropTypes.string.isRequired
};

export default ReturnStatusSelect;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/return-status-select.js